import { FullScreenConfetti } from './FullScreenConfetti'

export default FullScreenConfetti
